import React from "react";
import { motion } from "framer-motion";

export const fadeUp = {
    hidden: { opacity: 0, y: 24 },
    visible: (i = 0) => ({
        opacity: 1, y: 0,
        transition: { duration: 0.6, delay: i * 0.06, ease: [0.2, 0.7, 0.2, 1] }
    }),
};

export const SectionHeader = ({ kicker, title, lede, anchor }) => (
    <div className="mb-10 md:mb-14 max-w-3xl" id={anchor}>
        {kicker && (
            <div className="flex items-center gap-3 mb-4">
                <span className="ornament terra" />
                <span className="font-data text-[10px] tracking-[0.22em] uppercase terra">{kicker}</span>
            </div>
        )}
        <h2 className="font-display text-4xl md:text-5xl lg:text-6xl leading-[1.05] ink">{title}</h2>
        {lede && <p className="font-body text-base md:text-lg ink-mute mt-5 leading-relaxed">{lede}</p>}
    </div>
);

export const Reveal = ({ children, delay = 0, className = "" }) => (
    <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: "-60px" }}
        custom={delay}
        variants={fadeUp}
        className={className}
    >
        {children}
    </motion.div>
);

export const FlatCard = ({ children, className = "", ...rest }) => (
    <div className={`bg-white border hairline rounded-md ${className}`} {...rest}>{children}</div>
);
